module.exports = __webpack_public_path__ + "static/media/game_cover_rhythm.9a3ef459.png";